import { render } from "./SidebarNavCards.vue?vue&type=template&id=187cf73a&scoped=true"
import script from "./SidebarNavCards.vue?vue&type=script&lang=js"
export * from "./SidebarNavCards.vue?vue&type=script&lang=js"

import "./SidebarNavCards.vue?vue&type=style&index=0&id=187cf73a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-187cf73a"]])

export default __exports__